import HttpService from "./HttpService";

const API_ENDPOINT = "generate-comprehensive-report";

const ComprehensiveReportService = {
  async generateReport(payload) {
    try {
      const response = await HttpService.post(API_ENDPOINT, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  async generateAndDownload(payload) {
    try {
      const response = await HttpService.post(
        `${API_ENDPOINT}-download`,
        payload,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  async downloadExcel(id) {
    try {
      const response = await HttpService.get(
        `/download-comprehensive-report-xls/${id}`,
        {
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  async fetchGeneratedReports() {
    try {
      const response = await HttpService.get(
        `/comprehensive-generated-report-list`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default ComprehensiveReportService;
